<p-card header="My Requested Reports">
    <app-my-requested-responses></app-my-requested-responses>
</p-card>